module.exports = __webpack_public_path__ + "img/pin-truck.65894f6a.svg";